import { Component, Input, OnInit } from '@angular/core';
import { MembershipLevelMetadataLego } from '../../shared/dto/membership-level-metadata.lego';

@Component({
  selector: 'wl-membership-level-lego-summary',
  templateUrl: './membership-level-lego-summary.component.html',
  styleUrls: ['./membership-level-lego-summary.component.less'],
    standalone: false
})
export class MembershipLevelLegoSummaryComponent implements OnInit {
  @Input() membershipLevelData: MembershipLevelMetadataLego;

  constructor() {}

  ngOnInit(): void {}
}
